

// import React from "react";
// import {useWindowDimensions} from 'react-native';
// import { Box, View} from "native-base";
// import {  heightOfTopNav } from "../TopNavigator";
// import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
// import { ScrollView } from "react-native-gesture-handler";



// const ScreenWrapper: React.FC<any> = ({ children, navigation, route, scrollViewRef, noScroll}) => {    
//     console.log("ScreenWrapper route params:", route?.params);
//     const {isSmallVersion} = useAppContext();
   
//     const { width: windowWidth, height: windowHeight } = useWindowDimensions();

//     return (
//         <Box
//             // safeArea={true}
//             style={{
                
//                 position: 'relative',
//                 // flex: 1,  // Full height
//                 paddingTop: heightOfTopNav(isSmallVersion),
//                 height: (windowHeight) ? windowHeight  : '100vh', 
                
//                 width: windowWidth ?? '100vw',

//                 // ensure parity between rn.web and rn.native regarding requiring a scrollview in order to have scrolling
//                 overflow: 'hidden',
//                 backgroundColor: 'white' //"#F9F9F9",
//             }}
//         >   
      
//             {noScroll && <Box flex={1}>{children}</Box>}
//             {!noScroll && <ScrollView
//                 ref = {scrollViewRef}
//                 nestedScrollEnabled
//                 contentContainerStyle={{ 
//                     // flexGrow: 1,  // Ensure ScrollView content stretches
//                     flex: 1,
//                     height: windowHeight// - 40 - 30,  // Prevent extra space in ScrollView
//                 }}
//                 // showsVerticalScrollIndicator={false}
//                 bounces={false}  // Optional: disable bouncing effect
//             >
              
//                 {children}
//             </ScrollView>      }      
//             {/* <Footer /> */}
//             <View nativeID= 'foot-load-ya'/>
//         </Box>
//     );
// };

// export default React.memo(ScreenWrapper)
import { useWindowDimensions } from "react-native";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
import { heightOfTopNav } from "../TopNavigator";
import { Box, ScrollView } from "native-base";
import React from "react";



const ScreenWrapper: React.FC<any> = ({
  children,
  navigation,
  route,
  scrollViewRef,
  noScroll,
}) => {
  const { isSmallVersion } = useAppContext();
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();

  const topNavHeight = heightOfTopNav(isSmallVersion);
  const contentHeight = windowHeight - topNavHeight;

  return (
    <Box
      style={{
        position: "relative",
        paddingTop: topNavHeight,
        // даём занять всю доступную высоту, без жёсткого windowHeight/'100vh'
        flex: 1,
        width: windowWidth ?? "100vw",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      {noScroll ? (
        // экраны без ScrollView (Catalog) — высота контента = экран - навбар
        <Box style={{ height: contentHeight }}>
          {/*
            Прокидываем доступную высоту ребёнку.
            В твоём случае children — это один компонент (Catalog),
            так что можно сделать cloneElement.
          */}
          {React.isValidElement(children)
            ? React.cloneElement(children as any, { contentHeight })
            : children}
        </Box>
      ) : (
        <ScrollView
          ref={scrollViewRef}
          nestedScrollEnabled
          contentContainerStyle={{
            flexGrow: 1,
            // убираем фиксированную высоту, она и даёт лишний скролл
            // height: windowHeight,
          }}
          bounces={false}
        >
          {children}
        </ScrollView>
      )}

      <Box nativeID="foot-load-ya" />
    </Box>
  );
};

export default React.memo(ScreenWrapper)